import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from "react-modal";
import { allReminder,createReminder } from "../Apis/apis";

const Reminder = ({model}) => {
const currentDate = new Date();
const tomorrowDate = new Date(currentDate);
tomorrowDate.setDate(currentDate.getDate() + 1);
const tomorrowDateString = tomorrowDate.toISOString().split("T")[0];
  const initialState = {
    leadId:"",
    coustomerPhone:"",
    media_path_slug:"",
    remiderNote:"",
    remiderDate:tomorrowDateString,
    }
  const locations = useLocation();
  let navigation = useNavigate();
  const [open,setOpen] = useState(false);
  const [reminders,setReminders] = useState([]);
  const path = locations.pathname;
  const [reminderForm,setReminderForm] = useState(initialState)

  
  useEffect(()=>{
  reminderForm.leadId=model.id;
  reminderForm.coustomerPhone=model.phonenumber;
  reminderForm.media_path_slug=model.media_path_slug;
  },[model])

  const fatchData = async () => {
    const id=model.id;
    if(id){
      const data =  await allReminder(id)
      if(data.length>0){
        setReminders(data);
      }
      
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setReminderForm({ ...reminderForm, [name]: value });
  };

  const addReminder = async (e) => {
    e.preventDefault();
  
    for (const key in reminderForm) {
      if (!reminderForm[key]) {
       
        alert(`${key} is empty`);
        
        return;
      }
    }
    const data = await createReminder(path, reminderForm);
    if (data.message === "You are not authorized for this Action") {
      navigation("/");
    }
    if (data.message === "Reminder created successfully" ) {
      fatchData()
      setOpen(!open);
    }
  };
  

  useEffect(() => {
    fatchData();
  }, [model])
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear().toString(); // Take the last two digits
    return `${day}/${month}/${year}`;
  };
  return (
    <>

    <button onClick={() => {setOpen(!open)}} className="edit-btn  border-0" >New Reminder</button>
      <div className="container container mt-5 p-0">  
        
           
              
              <table className="table table-boarder table-hover table-striped  table-sm">
                    <thead className="thead-dark">
                  <tr>
                    <th scope="col">Description</th>
                    <th scope="col">Reminding date</th>
                    <th scope="col">Reminder set by</th>
                    <th scope="col">Status</th>
                    
                  </tr>
                </thead>
                {reminders.length>0 &&
                  <tbody>
                
                  { reminders.map((pos, index) => (
                    <tr key={index}>
                    <td>{pos.reminderNote}</td>
                    <td>{formatDate(pos.reminderDate)}</td>
                    <td>{pos.staff_email.split('@')[0]}</td>
                    <td>{pos.isnotified==1? "email sent":"upcoming"}</td>

                    </tr>))
                  }
                </tbody>
                }
              
              </table>
      </div>
      <Modal isOpen={open} className='form_modal h-auto'>
            <button className="border-0 float-right text-danger" onClick={(e) => setOpen(!open)}>X</button>
        <form onSubmit={addReminder} className=" ">
          <label className="mt-4">Remider date (mm/dd/yyyy)</label>
        <input type="date" name="remiderDate"  value={reminderForm.remiderDate} min={tomorrowDateString} onChange={handleChange} className="custom-select form-control "/>
      <br/>
      <label className="">Remider note</label>
      <input  type="text"  name="remiderNote" value={reminderForm.remiderNote}   onChange={handleChange} className="form-control ms-0 py-2 mt-0"  placeholder="Remider note"  />
      <div className="d-flex justify-content-center mt-4 ">
            <input className="w-50" type="submit" value="Save" />
          </div>
            </form>
            </Modal>
    </>


  );
};
export default Reminder;
